import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaUserCircle,
  FaMapMarkedAlt,
  FaEnvelope,
  FaSignInAlt,
  FaUserShield,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import "./Navbar.css";

export default function Navbar() {
  const [user, setUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Hamburger mobile
  const [isProfileOpen, setIsProfileOpen] = useState(false); // Dropdown profil
  const dropdownRef = useRef();
  const navigate = useNavigate();

  // Récupération de l'utilisateur depuis le localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  // Fermer le dropdown profil quand on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Déconnexion
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    localStorage.clear();
    navigate("/");
  };

  const menuItemStyle = {
    padding: "0.75rem 1.5rem",
    cursor: "pointer",
    alignItems: "center",
    transition: "all 0.2s ease",
  };

  const iconStyle = {
    marginRight: "0.5rem",
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="navbar-logo">
        <img src="/logo.png" alt="Logo" className="logo" />
      </div>

      {/* Hamburger mobile */}
      <div
        className="hamburger"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Menu principal */}
      <ul className={`navbar-menu ${isMenuOpen ? "open" : ""}`}>
        <li>
          <Link
            to="/Mapview"
            className="active"
            onClick={() => setIsMenuOpen(false)}
          >
            <FaMapMarkedAlt style={iconStyle} /> Géoportail
          </Link>
        </li>
        <li>
          <Link to="/admin" onClick={() => setIsMenuOpen(false)}>
            <FaUserShield style={iconStyle} /> Espace Admin
          </Link>
        </li>
        <li>
          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
            <FaEnvelope style={iconStyle} /> Contact
          </Link>
        </li>

        {/* Connexion / Profil */}
        {!user ? (
          <li>
            <Link to="/page accueil" onClick={() => setIsMenuOpen(false)}>
              <FaSignInAlt style={iconStyle} /> Connexion
            </Link>
          </li>
        ) : (
          <li className="navbar-profile" ref={dropdownRef}>
            <Link
              to="/profile"
              className="profile-link"
              onClick={(e) => {
                e.preventDefault();
                setIsProfileOpen(!isProfileOpen);
              }}
            >
              <FaUserCircle
                size={20}
                style={{ ...iconStyle, verticalAlign: "middle" }}
              />
              <span>{user.name}</span>
            </Link>

            {isProfileOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "75px",
                  right: 10,
                  width: "260px",
                  backgroundColor: "#fff",
                  boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
                  borderRadius: "16px",
                  padding: "1rem",
                  zIndex: 2000,
                  fontSize: "0.95rem",
                  color: "#333",
                }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#0f709e",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    margin: "0 auto 1rem auto",
                  }}
                >
                  {user.name.charAt(0).toUpperCase()}
                </div>

                <div
                  style={{
                    ...menuItemStyle,
                    padding: "0.75rem 1rem",
                    borderBottom: "1px solid #eee",
                    textAlign: "center",
                  }}
                >
                  <strong>{user.name}</strong>
                </div>

                <div
                  style={{
                    ...menuItemStyle,
                    padding: "0.75rem 1rem",
                    borderBottom: "1px solid #eee",
                    textAlign: "center",
                  }}
                >
                  {user.email}
                </div>

                <div
                  style={{
                    ...menuItemStyle,
                    padding: "0.75rem 1rem",
                    color: "#0f709e",
                    fontWeight: 500,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    justifyContent: "center",
                    transition: "all 0.2s ease",
                  }}
                  onClick={handleLogout}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f0f8ff";
                    e.currentTarget.style.transform = "scale(1.02)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <FiLogOut style={{ ...iconStyle, color: "#0f709e" }} /> Déconnexion
                </div>
              </div>
            )}
          </li>
        )}
      </ul>
    </nav>
  );
}
